import { Theme } from '@mui/material';
/**
 * @example styles for scrollling
 */
const ccfAppStyles = (theme: Theme) => {
  const styles = {
    scroll: {
      /* width */
      '*::-webkit-scrollbar': {
        width: '4px',
        height: '4px',
      },
      /* Track */
      '*::-webkit-scrollbar-track': {
        // backgroundColor: '#f4f7f9',
        backgroundColor: '#f4f7f9',
        // backgroundColor: color.scrollTrack,
      },
      /* Handle */
      '*::-webkit-scrollbar-thumb': {
        // backgroundColor: '#c9d0d6',
        backgroundColor: '#c9d0d6',
        // backgroundColor: color.scrollThumb,
        borderRadius: '30px',
      },
      /* Handle on hover */
      '*::-webkit-scrollbar-thumb:hover': {
        // backgroundColor: '#5555',
        backgroundColor: '#5555',
        // backgroundColor: color.scrollThumbHover,
      },
    },
  };
  return styles;
};

export default ccfAppStyles;
